import {useIntl} from 'react-intl'
import {MessageItemCommonProps, MessageSelectService} from '../../definitions'
import {useChatbotContext} from '../../context'
import {convertCurrency} from '../../../../../_gori/helpers'
import clsx from 'clsx'
import {pick} from 'lodash'

type MessageItemSelectServiceProps = MessageItemCommonProps<MessageSelectService>

const ServiceItem = ({service, name}: {service: any; name: string}) => {
  const intl = useIntl()

  return (
    <div
      className={clsx(
        'd-flex rounded p-3 w-100 flex-column gap-3 align-items-center border-2 border h-100',
        `select-service-${name}`
      )}
    >
      <div className='text-decoration-underline fw-bolder fs-5'>
        {intl.formatMessage({id: name.toUpperCase()})}
      </div>
      <div className='d-flex flex-column align-items-center mt-1 gap-1 text-center'>
        <img src={service.logo} className='h-30px align-self-center' alt='logo-shipment' />
        <span className='fw-bold'>{service.services}</span>
        <span className='fs-2 fw-boldest'>{convertCurrency(service.cost)}</span>
      </div>
    </div>
  )
}

export const MessageItemSelectService = ({message}: MessageItemSelectServiceProps) => {
  const {disabledUserAction} = useChatbotContext()
  return (
    <div>
      <div className='d-flex gap-3'>
        {Object.entries(pick(message.content, ['best', 'cheapest', 'fastest']))?.map(
          ([key, item]) => (
            <div
              key={key}
              className={clsx('w-100', {
                'cursor-not-allowed': disabledUserAction,
              })}
            >
              <ServiceItem service={item} name={key} />
            </div>
          )
        )}
      </div>
    </div>
  )
}
